import { TeamsProvider } from '../../../app/contexts/TeamsContext'
import { TeamsPage } from './TeamsPage'

export const Teams = () => {
  return (
    <TeamsProvider>
      <TeamsPage />
    </TeamsProvider>
  )
}
